import {createRouter, createWebHistory, RouteRecordRaw} from "vue-router";
import {useAuthStore} from "../stores/auth.store";
import {authGuard} from './auth.guard';

const routes: Array<RouteRecordRaw> = [
    {
        path: "/",
        name: "LoginSignUp",
        component: () => import("@/views/LoginSignUp.vue"),
        meta: {title: "Đăng nhập", requiresAuth: false, layout: "default"},

    },
    {
        path: "/auth/google/callback",
        name: "GoogleCallback",
        component: () => import("@/views/GoogleCallbackPage.vue"),
        meta: {requiresAuth: false},
    },
    {
        path: "/forgot-password",
        name: "ForgotPassword",
        component: () => import("@/views/ForgotPassword.vue"),
        meta: {title: "Quên mật khẩu", requiresAuth: false},

    },
    {
        path: "/reset-password",
        name: "ResetPassword",
        component: () => import("@/views/ResetPassword.vue"),
        meta: {title: "Đặt lại mật khẩu", requiresAuth: false},
    },
    {
        path: "/home",
        name: "ListRecord",
        component: () => import("@/views/ListRecord.vue"),
        meta: {title: "Danh sách bản ghi", requiresAuth: true},
    },
    {
        path: "/dashboard",
        name: "Dashboard",
        component: () => import("@/views/DashboardPage.vue"),
        meta: {title: "Dashboard", requiresAuth: true, layout: "dashboard"},
    },
    {
        path: "/voice",
        name: "VoiceId",
        component: () => import("@/views/VoiceId.vue"),
        meta: {title: "Định danh giọng nói", requiresAuth: true},
    },
    {
        path: "/huong-dan",
        name: "UserGuide",
        component: () => import("@/views/UserGuide.vue"),
        meta: {title: "Hướng dẫn sử dụng", requiresAuth: true, layout: "dashboard"},
    },
    {
        path: "/projects",
        name: "ProjectList",
        component: () => import("@/views/ProjectList.vue"),
        meta: {title: "Dự án", requiresAuth: true, layout: "dashboard"},
    },
    {
        path: "/projects/:projectId",
        name: "ProjectDetail",
        component: () => import("@/views/ProjectDetail.vue"),
        meta: {title: "Chi tiết dự án", requiresAuth: true, layout: "dashboard"},
    },
    {
        path: "/detail/:recordId",
        name: "DetailRecord",
        component: () => import("@/views/DetailRecord.vue"),
        meta: {title: "Chi tiết", requiresAuth: true},
    },
    {
        path: "/record/:recordId",
        name: "Detail Record",
        component: () => import("@/views/DetailRecordNew.vue"),
        meta: {title: "Chi tiết", requiresAuth: true, layout: "detail"},
    },
    {
        path: "/share/:recordId",
        name: "ShareRecord",
        component: () => import("@/views/DetailRecordNew.vue"),
        meta: {title: "Chia sẻ", requiresAuth: false, layout: "detail"},
    },
];
const router = createRouter({
    history: createWebHistory(process.env.BASE_URL),
    routes,
});

// router.beforeEach(async (to) => {
//   const publicPages = ["/"];
//   const authRequired = !publicPages.includes(to.path);
//   const auth = useAuthStore();
//   const currentAuth = localStorage.getItem("user") !== null;
//   if (!auth.isLoggedIn && authRequired && !currentAuth) {
//     return "/";
//   }
// });
router.beforeEach(authGuard);

export default router;
